<!-- 召回报表列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <recallRetrieveReportInitAction v-if="showStatus" ref="recallRetrieveReportInitAction"
                @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData">
            </recallRetrieveReportInitAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
                @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData
                    v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight"
                :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column label="选择操作" width="90">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>

                <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip
                    :min-width="tableValye.fieldWeight"
                    v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                    :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                        </span>
                        <span v-else-if="tableValye.entityField == 'createTime'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>

           
                        <el-tag v-else-if="tableValye.entityField == 'state'" size="mini" type="primary">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                                 <span v-else-if="tableValye.fieldType == 'formatter'">
                            {{ $common.getIsGsp(tableValye.formatterContent,
                                scope.row[tableValye.entityField])
                            }}
                        </span>

                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import recallRetrieveReportInitAction from '@/components/recallRetrieveReportInitAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
		recallRetrieveReportInitAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,

            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            showStatus: false,
            actionData: {},

            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.opmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.ovmApper = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },

        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        
        isShowData(name, value) {
            switch (name) {
                case "ovmApper":
                    var dataInfo = JSON.parse(sessionStorage.getItem("selectUserData"));
                    this.getRequestData.ovmApper = dataInfo.opmId;
                    this.getRequestData.opmName = dataInfo.opmName;
                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.getButtonList();
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.formDataList = this.pageShowData.jurFormVoList
                this.pageShowData.jurHead && this.pageShowData.jurHead.jurconfigform.forEach((item) => {
                    item.setField && this.initParamValue(item.setField)
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
                case 1:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    var dataInfo = JSON.parse(
                        JSON.stringify(this.returnData.list[this.selectedDataIndex])
                    );
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
             
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: dataInfo.rcrId,
                        printSouce: '',
                        printJurId: ''
                    }
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.submitData();
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.queryReportInit(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 提交审核
        async submitData() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            // this.$confirm("确定要提交审核吗？", "提示", {
            // 		confirmButtonText: "确定",
            // 		cancelButtonText: "取消",
            // 		type: "warning",
            // 	})
            // 	.then(async () => {
            var delData = {
                businessKey: dataInfo.rcrId,
            };
            let responseData = await this.$http.rcnSubmitReport(delData);
            if (responseData.status == 200) {
                this.$message({
                    type: "success",
                    message: "操作成功!",
                });

                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            // })
            // .catch(() => {});
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
            }
            var dataInfo = JSON.parse(
                JSON.stringify(this.returnData.list[this.selectedDataIndex])
            );
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.rcrId],
                    };
                    let responseData = await this.$http.rcnDelReport(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>